<template>
<div>
    <div class="mcc-page-header">
        <section class="mu-d-flex mu-w-100">
            <h1 class="mu-mb-00">Dashboard</h1>
            <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
 
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
           
        </section>
    </div>
    <div class="mcc-container-fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Administration </li>
                <li>Dashboard</li>
            </ol>
        </nav>
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-tabs mcc-tabs--compact mcc-tabs--bar" active-index="0" @change="handleTabChange($event)">
                        <input type="radio" id="instances" name="as-default-tab-control" checked="" />
                        <input type="radio" id="taskTab" name="as-default-tab-control" />
                        <ul role="tablist" class="mu-bg-container-01 mu-pt-07 mu-pl-06 mu-radius-top-02 mu-border-top mu-border-start mu-border-end">
                            <li role="tab">
                                <label for="instances" tabindex="0">
                                    <span>Process instance</span>
                                </label>
                            </li>
                            <li role="tab">
                                <label for="taskTab" tabindex="0">
                                    <span>Task</span>
                                </label>
                            </li>
                        </ul>
                        <div role="tabpanel">
                            <div class="mcc-card mu-radius-top-00">
                                <div class="mcc-card__body">
                                    <div class="mcc-intrinsic-grid" style="--mds-intrinsic-grid-min: 38ch">
                                        <div class="mcc-card mcc-card--primary-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{dto.totalProcesses}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Total</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" @click="viewProcesses('all')">
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-card mcc-card--warning-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{dto.activeProcesses}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Active</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" @click="viewProcesses('active')">
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-card mcc-card--danger-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{dto.terminatedProcesses}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Terminated</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" disabled>
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-card mcc-card--success-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{dto.completedProcesses}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Completed</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" @click="viewProcesses('completed')">
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mcc-row mu-mt-05">
                                        <div class="mcc-col mcc-col-12 mcc-col-md-6">
                                            <div class="mcc-card">
                                            <div class="mcc-card__body">
                                                <div class="mcc-row">
                                                    <div class="mcc-col">
                                                        <div class="chart-content" style="height: 500px;" id="processDefByCategory"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="mcc-col mcc-col-12 mcc-col-md-6">
                                            <div class="mcc-card">
                                            <div class="mcc-card__body">
                                                <div class="mcc-row">
                                                    <div class="mcc-col">
                                                        <div class="chart-content" style="height: 500px;" id="processByUsers"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div role="tabpanel">
                            <div class="mcc-card mu-radius-top-00">
                                <div class="mcc-card__body">
                                    <div class="mcc-intrinsic-grid" style="--mds-intrinsic-grid-min: 38ch">
                                        <div class="mcc-card mcc-card--primary-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{taskDto.totalTasks}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Total</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" @click="viewTasks('all')">
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-card mcc-card--warning-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{taskDto.claimedTask}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Claimed</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" disabled>
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-card mcc-card--danger-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{taskDto.unClaimedTask}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Unclaimed</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" disabled>
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-card mcc-card--success-soft">
                                            <div class="mcc-card__body">
                                                <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                                                    <div>
                                                        <div class="mu-fw-bold mu-fs-1">{{taskDto.completedTask}}</div>
                                                        <div class="mu-fw-medium mu-fs-4">Completed</div>
                                                    </div>
                                                    <div>
                                                        <button class="mcc-button mcc-button--outline" @click="viewTasks('completed')">
                                                            <span class="mcc-button__label">View Details</span>
                                                            <mcc-icon name="arrows_long_right" aria-hidden="true"></mcc-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mcc-card mu-mt-06">
                                        <div class="mcc-card__body">
                                            <div class="chart-content " style="height: 500px;" id="taskStastics"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import DashboardAPI from "../../../services/DashboardAPI";
import Utils from "@/script_utils";

export default {
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["admin.dashboard"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            updateCall: true,
            taskLoaded: false,
            dto: {
                activeProcesses: 0,
                completedProcesses: 0,
                suspendedProcesses: 0,
                terminatedProcesses: 0,
                totalProcesses: 0
            },
            taskDto: {
                totalTasks: 0,
                unClaimedTask: 0,
                claimedTask: 0,
                completedTask: 0
            },

        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.loadInstanceDetails();
    },
    methods: {
        viewTasks(type) {
            localStorage
                .setItem(
                    'taskType', type);
            this.$router.push(
                this.CONTEXT_PATH + "/processengine/tasks"
            );
        },
        loadInstanceDetails() {
            let self = this;
            if (am4core && am4core.options) {
                am4core.options.commercialLicense = true;
            }
            self.updateCall = false;
            DashboardAPI.getProcessInfo()
                .then(result => {
                    self.dto = result;
                })
                .finally(() => {
                    self.updateCall = true;
                    self.loadInstanceCharts();
                });
        },
        viewProcesses(type) {
            if (type != "active") {
                localStorage
                    .setItem(
                        'processType', type);
            }
            this.$router.push(
                this.CONTEXT_PATH + "/processengine/processes"
            );
        },
        async loadInstanceCharts() {
            await this.$nextTick();
            let self = this;
            setTimeout(function () {
                if (self.dto.processDefinitions) {
                    self.displayProcessDefinitionsCategory(self.dto);
                }
                if (self.dto.groupByUser) {
                    self.displayProcessByUser(self.dto);
                }
            }, 0);

        },
        displayProcessDefinitionsCategory(responseData) {

            let processDefData = responseData.processDefinitions;
            let self = this;

            if (processDefData.length > 0) {
                am4core
                    .ready(function () {
                        am4core.useTheme(am4themes_animated);
                        let chart = am4core.create("processDefByCategory",
                            am4charts.PieChart3D);
                        chart.paddingTop = 15;
                        chart.paddingLeft = 15;
                        let title = chart.titles.create();
                        chart.numberFormatter.numberFormat = "#.##";
                        title.text = "[bold]Process by category[/]";
                        title.marginBottom = 30;
                        chart.data = processDefData;
                        chart.innerRadius = am4core.percent(30);
                        let pieSeries = chart.series
                            .push(new am4charts.PieSeries3D());
                        pieSeries.labels.template.disabled = true;
                        pieSeries.dataFields.value = "dataLength";
                        pieSeries.dataFields.category = "categoryName";
                        pieSeries.labels.template.text = "{category} {value.percent}% ({value})";
                        pieSeries.slices.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
                        pieSeries.slices.template.stroke = am4core.color("#fff");
                        pieSeries.slices.template.strokeWidth = 2;
                        pieSeries.slices.template.strokeOpacity = 1;
                        pieSeries.slices.template.events
                            .on(
                                "hit",
                                function (event) {
                                    if (event.target.dataItem &&
                                        event.target.dataItem.category &&
                                        event.target.dataItem.category != "No Category") {
                                        localStorage
                                            .setItem(
                                                'processDefinitionCategory',
                                                event.target.dataItem.category);
                                        self.$router.push(
                                            self.CONTEXT_PATH + "/processengine/processdefinitions"
                                        );

                                    }
                                }, this);

                        pieSeries.hiddenState.properties.opacity = 1;
                        pieSeries.hiddenState.properties.endAngle = -90;
                        pieSeries.hiddenState.properties.startAngle = -90;
                        chart.legend = new am4charts.Legend();
                        chart.legend.maxColumns = 2;
                        chart.exporting.menu = new am4core.ExportMenu();
                        let annotation = chart.plugins
                            .push(new am4plugins_annotation.Annotation());
                    })
            } else {
                $('#processDefByCategory').hide();
            }

        },
        handleTabChange(e) {

            let self = this;

            if (e.target.id == "taskTab" && !self.taskLoaded) {
                self.taskLoaded = true;
                self.getTaskData();

            }

        },
        getTaskData() {
            let self = this;
            self.updateCall = false;
            DashboardAPI.getTaskData()
                .then(result => {
                    self.taskDto = result;
                })
                .finally(() => {
                    self.updateCall = true;
                    self.loadTaskData(self.taskDto);
                });
        },
        loadTaskData(responseData) {
            let taskGraphData = [{
                "taskTitle": "Tasks over due",
                "taskLength": responseData.overDueTasks
            }, {
                "taskTitle": "Tasks due today",
                "taskLength": responseData.dueTodayTasks
            }];

            am4core
                .ready(function () {
                    am4core.useTheme(am4themes_animated);
                    let chart = am4core.create("taskStastics", am4charts.XYChart3D);
                    let title = chart.titles.create();
                    title.text = "[bold]Tasks statistics[/]";
                    title.marginBottom = 30;
                    chart.data = taskGraphData;
                    let categoryAxis = chart.xAxes
                        .push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "taskTitle";
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.renderer.minGridDistance = 30;
                    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.title.text = "[bold]Total[/]";
                    let series = chart.series.push(new am4charts.ColumnSeries3D());
                    series.dataFields.valueY = "taskLength";
                    series.dataFields.categoryX = "taskTitle";
                    series.name = "TaskLength";
                    series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
                    series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                    series.columns.template.fillOpacity = .8;
                    let columnTemplate = series.columns.template;
                    columnTemplate.strokeWidth = 2;
                    columnTemplate.strokeOpacity = 1;
                    chart.exporting.menu = new am4core.ExportMenu();
                    let annotation = chart.plugins
                        .push(new am4plugins_annotation.Annotation());
                })
        },
        displayProcessByUser(responseData) {
            let startedByUserData = responseData.groupByUser;

            if (startedByUserData.length > 0) {
                am4core
                    .ready(function () {
                        am4core.useTheme(am4themes_animated);
                        let chart = am4core.create("processByUsers",
                            am4charts.XYChart);
                        let title = chart.titles.create();
                        title.text = "[bold]Process started by user[/]";
                        title.marginBottom = 30;
                        chart.data = startedByUserData;
                        let categoryAxis = chart.yAxes
                            .push(new am4charts.CategoryAxis());
                        categoryAxis.dataFields.category = "username";
                        categoryAxis.numberFormatter.numberFormat = "#";
                        categoryAxis.renderer.inversed = true;
                        categoryAxis.renderer.minGridDistance = 10;
                        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                        valueAxis.min = 0;
                        $
                            .each(
                                responseData.categories,
                                function (index, categoryName) {
                                    let updateCatName = categoryName;
                                    if (updateCatName == null || updateCatName == "") {
                                        updateCatName = "No Category";
                                    }
                                    let stacked = true;
                                    if (index == 0) {
                                        stacked = false;
                                    }
                                    let series = chart.series
                                        .push(new am4charts.ColumnSeries());
                                    series.dataFields.valueX = updateCatName;
                                    series.dataFields.categoryY = "username";
                                    series.name = updateCatName;
                                    series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
                                    series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
                                    series.stacked = stacked;
                                    series.columns.template.width = am4core
                                        .percent(95);
                                });
                        chart.legend = new am4charts.Legend();
                        chart.legend.maxColumns = 2;
                        chart.exporting.menu = new am4core.ExportMenu();
                        let annotation = chart.plugins
                            .push(new am4plugins_annotation.Annotation());
                    });
            } else {
                $('#processByUsers').hide();
            }
        }
    }
};
</script>

<style scoped>
.mcc-card__footer {
    cursor: pointer;
}

a[title="Chart created using amCharts library"] {
    display: none !important;
}
</style>
